module.exports = __webpack_public_path__ + "static/media/erik-lucatero-2.2051e0e8.jpg";